module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon6.392027d6.svg";